import React, { useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Toast(props) {
    const toastShownRef = useRef(false);

    useEffect(() => {
        if (!props.data) return;

        // prevent duplicate toasts on re-render
        if (toastShownRef.current && toast.isActive(props.id)) return;

        toastShownRef.current = true;

        // close any existing toast before opening a new one
        toast.dismiss();

        toast(props.data, {
            toastId: props.id,
            type: props.type,
            // default auto-close after 7s; pass autoClose={false} to keep the
            // toast open until the user closes it manually
            autoClose: props.autoClose !== undefined ? props.autoClose : 7000,
            closeOnClick: false,
            draggable: false,
            onClose: () => {
                toastShownRef.current = false;

                // OPTIONAL: clear parent state if handler exists
                if (typeof props.onClose === "function") {
                    props.onClose();
                }
            }
        });
    }, [props.data, props.type, props.id]);

    return (
        <ToastContainer
            position="bottom-center"
            autoClose={4000}
            draggable={false}
            closeOnClick={false}
            pauseOnHover={true}
        />
    );
}

export default Toast;
